import { Sizes } from 'styled-components';
import { styled } from '../../core/theme/styled';

type StyledImageProps = {
  height: Sizes;
};

export const StyledImage = styled.img<StyledImageProps>`
  height: ${(props) => props.theme.sizes[props.height]};
  width: auto;
  /* Using css-filter to only apply shadow to non-transparent pixels in a png */
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
`;
